import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "whitelist": {
        "title": "Darb Assabil WordPress Plugin - Beta",
        "subtitle": "Join our exclusive whitelist for early access at a discounted price",
        "features": {
          "earlyAccess": "Early access to our darb assabil plugin",
          "discount": "Special discounted pricing for whitelist members",
          "support": "Priority support during launch phase"
        },
        "serviceCheckbox": "Do you need Huruf's services for installation of this plugin?",
        "joinButton": "Join Whitelist",
        "connecting": "Connecting...",
        "footer": "A Product of",
        "errors": {
          "network": "Could not connect to the server. Please try again later.",
          "noLoginUrl": "No login URL received from server."
        },
        "toasts": {
          "alreadyWhitelisted": {
            "title": "User already whitelisted",
            "description": "You are already on the whitelist. No further action is needed."
          },
          "success": {
            "title": "Success!",
            "description": "You have been successfully added to the whitelist."
          }
        }
      }
    }
  },
  ar: {
    translation: {
      "whitelist": {
        "title": "درب السبيل - إضافة ووردبريس (تجريبي)",
        "subtitle": "انضم إلى قائمتنا الحصرية للوصول المبكر بسعر مخفض",
        "features": {
          "earlyAccess": "وصول مبكر إلى إضافة درب السبيل",
          "discount": "أسعار مخفضة خاصة لأعضاء القائمة",
          "support": "دعم ذو أولوية خلال مرحلة الإطلاق"
        },
        "serviceCheckbox": "هل تحتاج إلى خدمات حروف لتثبيت هذه الإضافة؟",
        "joinButton": "انضم إلى القائمة",
        "connecting": "جاري الاتصال...",
        "footer": "منتج من",
        "errors": {
          "network": "تعذر الاتصال بالخادم. يرجى المحاولة مرة أخرى لاحقاً.",
          "noLoginUrl": "لم يتم استلام رابط تسجيل الدخول من الخادم."
        },
        "toasts": {
          "alreadyWhitelisted": {
            "title": "المستخدم مسجل بالفعل",
            "description": "أنت مسجل بالفعل في القائمة. لا يلزم اتخاذ أي إجراء آخر."
          },
          "success": {
            "title": "تم بنجاح!",
            "description": "تمت إضافتك بنجاح إلى القائمة."
          }
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 